export const CLIENT_ID='lk9hyx24834i7j25guphvmkwvgp86s'
export const REDIRECT_URI='https://streamstats.seve.dev'